import React from 'react'
import { PageHeading } from '../../components/common/pageHeading/PageHeading'
import { Verification } from '../../components/user/verfication/Verification'
import styles from './accountVerification.module.css'

export const AccountVerification = () => {
  return (
    <main>
      <PageHeading title={'Account Verification'} />
      <div className={styles.verification_container}>
        <Verification />
      </div>
    </main>
  )
}
